import { inject, Injectable } from '@angular/core';
import {
  BasicDialogService,
  DialogPresets,
} from '@principle-theorem/ng-shared';
import { OrganisationService } from '@principle-theorem/ng-principle-shared';
import { snapshot } from '@principle-theorem/shared';
import { type IManagementTool } from '../models/management-tool';
import { ManagementResource } from '../models/management-resource';
import {
  type IFeeScheduleCleanupDialogData,
  FeeScheduleCleanupDialogComponent,
} from '../fee-schedule-cleanup-dialog/fee-schedule-cleanup-dialog.component';

@Injectable({ providedIn: 'root' })
export class FeeScheduleCleanupTool implements IManagementTool {
  private _dialog = inject(BasicDialogService);
  private _organisation = inject(OrganisationService);

  readonly name = 'fee-schedule-cleanup';
  readonly label = 'Fee Schedule Cleanup';
  readonly icon = 'receipt_long';
  readonly description =
    'View and delete practice & staffer level fee schedules, and toggle the feature flag';
  readonly resource = ManagementResource.Brand;

  async run(): Promise<void> {
    const organisation = await snapshot(this._organisation.organisation$);
    if (!organisation) {
      return;
    }
    const data: IFeeScheduleCleanupDialogData = { organisation };
    this._dialog.open(
      FeeScheduleCleanupDialogComponent,
      DialogPresets.large({ data })
    );
  }
}
